const logout = () => {
  localStorage.removeItem('access')
  localStorage.removeItem('refresh')
}

export default logout
